import React from 'react';
import { toUSD } from "../../util/currency-formatter";
import CustomTable from "../table/table";
import "./breakdown.scss";

const MaterialCostsTable = ({ costDetails, handleViewPO, handleViewInvoice }) => {
  const materialColumns = [
    // { field: "type", title: "Type" },
    {
      field: "poNumber",
      title: "PO Number",
      render: (item) => (
        <span
          className="po-link"
          onClick={() => handleViewPO(item.poId)}
        >
          {/* procurementCode is the PO number with project prefix and Suffix if null then default to po Number*/}
          {item.procurementCode || item.poNumber} 
        </span>
      )
    },
    {
      field: "invoiceNo",
      title: "Invoice Number",
      render: (item) => (
        <span
          className="invoice-link"
          onClick={() => handleViewInvoice(item.invoiceNo, item.invoiceData, item.invoiceId, false)}
        >
          {item.invoiceNo}
        </span>
      )
    },
    { field: "materialName", title: "Material" },
    { field: "date", title: "Date" },
    {
      field: "subTotal",
      title: "Amount",
      class: "text-right",
      render: (item) => <span className="text-right">{toUSD(item.subTotal)}</span>
    }
  ];

  const materialData = costDetails.filter(item => item.type === 'PO' || item.type === 'WPO');
  const materialSubtotal = materialData.reduce((sum, item) => sum + (item.subTotal || 0), 0);

  // Add subtotal row to display at the bottom
  const materialDataWithSubtotal = [...materialData
    //     , {
    //     id: 'material-subtotal',
    //     type: '',
    //     poNumber: '',
    //     invoiceNo: '',
    //     materialName: '',
    //     date: '',
    //     subTotal: materialSubtotal,
    //     isSubtotalRow: true // Flag to identify this as a special row
    //   }
  ];

  return (
    <div className="breakdown-container mt-3">
      <CustomTable
        columns={materialColumns}
        data={materialDataWithSubtotal}
        toolbar={true}
        exportButton={true}
        enableSearch={true}
        itemsPerPageCustom={false}
      />

      <div className="mt-3 border d-flex justify-content-between align-items-center p-2">
        <p className='mb-0 subtotal'>Material Subtotal</p>
        <p className='mb-0 subtotal'>{toUSD(materialSubtotal)}</p>
      </div>
    </div>
  );
};

export default MaterialCostsTable; 